import type { Certification } from "../api/dpp.js";

/** "YYYY-MM-DD" of the expiry, or the "no expiry" label. */
export function certValidity(c: Certification, noExpiryLabel: string): string {
  return c.validUntil ? c.validUntil.slice(0, 10) : noExpiryLabel;
}
